module.exports = __webpack_public_path__ + "img/smart logo@2x.19716a8f.png";